<template>
  <WdsStack
    class="tw-border tw-border-gray-200 tw-rounded-md tw-bg-white tw-w-full tw-mb-3"
    direction-column
    gap-sm
  >
    <WdsStack justify-space-between align-center class="tw-p-6 tw-pb-3">
      <WdsStack align-center gap-sm>
        <AvatarWithFallback
          :id="client.company.id"
          md
          :avatar="client.company.avatar"
          :alt="client.company.name"
        />
        <WdsStack direction-column gap-sm class="tw-ms-2">
          <WdsStack align-center>
            <WdsLabel
              :subtle="client.status === ContactStatus.Active"
              :warning="client.status === ContactStatus.Invited"
              :success="client.status === ContactStatus.Active"
            >
              •
              {{
                client.status === ContactStatus.Active
                  ? $t(activeStatusLabel)
                  : $t('Pending invite')
              }}
            </WdsLabel>
            <slot name="subtitle" />
          </WdsStack>
          <WdsHeading type="title2">{{ client.company.name }}</WdsHeading>
        </WdsStack>
      </WdsStack>

      <WdsStack align-center class="tw-gap-5">
        <slot name="actions" />
      </WdsStack>
    </WdsStack>

    <slot name="banner" />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsHeading, WdsLabel, WdsStack } from '@worksome/wds-components'
import AvatarWithFallback from '@/components/AvatarWithFallback.vue'
import { useTranslation } from '@/composables/translation'
import { ContactStatus } from '@/gql/graphql'

const { $t } = useTranslation()

withDefaults(
  defineProps<{
    client: {
      id: string
      status: typeof ContactStatus[keyof typeof ContactStatus]
      company: {
        id: string
        name: string
        avatar?: string | null
      }
    }
    activeStatusLabel?: string
  }>(),
  {
    activeStatusLabel: 'Active profile',
  },
)
</script>
